import React from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';
import { useI18n } from '../../contexts/I18nContext';

interface LinkGoogleButtonProps {
  onSuccess?: () => void;
}

const LinkGoogleButton: React.FC<LinkGoogleButtonProps> = ({ onSuccess }) => {
  const { linkGoogleAccountWithVerification, loading } = useAuth();
  const { t } = useI18n();
  const [error, setError] = React.useState<string | null>(null);

  const handleClick = async () => {
    setError(null);
    try {
      await linkGoogleAccountWithVerification();
      onSuccess?.();
    } catch (e: any) {
      setError(e?.message || 'Error al vincular cuenta con Google');
    }
  };

  return (
    <div className="space-y-2">
      <motion.button
        type="button"
        onClick={handleClick}
        disabled={loading}
        whileTap={{ scale: 0.98 }}
        className="w-full bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 text-gray-800 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-slate-700 font-medium py-3 px-6 rounded-2xl transition-all duration-200 flex items-center justify-center space-x-3"
      >
        <img src="https://www.gstatic.com/images/branding/product/1x/gsa_64dp.png" alt="Google" className="w-5 h-5" />
        <span>{loading ? t('loading') : 'Vincular con Google'}</span>
      </motion.button>
      {error && (
        <div className="text-sm text-red-600 dark:text-red-400 text-center">{error}</div>
      )}
    </div>
  );
};

export default LinkGoogleButton;